import { Skeleton, TextSkeleton } from '@wwe-portal/ui/components/skeleton';

export const AppbarSkeleton = () => {
  return (
    <div className="z-topbar bg-back600 border-back300 data-[search-open=true]:z-globalSearchInput fixed inset-x-0 top-0 flex h-[60px] items-center justify-between overflow-hidden px-5 transition-colors md:border-b-0 xl:left-[240px] xl:right-[280px] xl:h-[70px] xl:w-auto xl:px-[30px]">
      <div className="flex">
        <div className="flex items-center gap-5">
          <Skeleton className="h-5 w-5 xl:hidden" />
          <div className="flex gap-2">
            <Skeleton className="h-[26px] w-[26px]" />
            <div className="flex flex-col">
              <TextSkeleton
                lineHeight={18}
                fontSize={12}
                className="w-[200px]"
              />
              <TextSkeleton lineHeight={9} fontSize={9} className="w-20" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
